import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnotationStore } from '../../../claim-annotator/domain/annotation-store';
import { ClaimSetState } from '../../../claim-annotator/domain/claim-set-state';

interface ClaimRow {
  id: string;
  text: string;
  color: string;
  count: number;
  pages: number[];
  active: boolean;
}

type SidebarState =
  | { kind: 'no-document' }
  | { kind: 'no-claims' }
  | { kind: 'ready'; rows: ClaimRow[] };

@Component({
  selector: 'app-cad-claims-sidebar',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './claims-sidebar.component.html',
})
export class ClaimsSidebarComponent {
  private store = inject(AnnotationStore);
  private claims = inject(ClaimSetState);

  readonly state = computed<SidebarState>(() => {
    const docId = this.store.activeDocumentId();
    if (!docId) return { kind: 'no-document' };
    const claims = this.claims.getForDocument(docId);
    if (claims.length === 0) return { kind: 'no-claims' };
    const active = this.claims.activeClaimId();
    const rows: ClaimRow[] = claims.map((c) => ({
      id: c.id,
      text: c.text,
      color: this.store.colorForClaim(c.id),
      count: this.store.annotationsByClaim(c.id).length,
      pages: this.store.pagesWithBoxes(c.id),
      active: active === c.id,
    }));
    return { kind: 'ready', rows };
  });

  onCardClick(id: string): void {
    this.claims.setActiveClaim(id);
  }
}
